import { useState } from 'react';
import { useAdminFetch } from '../api/fetch';

export const useDialog = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const openDialog = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    openDialog,
    closeDialog
  };
};

export interface UnattendedDialogProps {
  initialLectureName?: string;
  initialVideoName?: string;
}

export const useUnattendedDialog = ({
  initialLectureName = '',
  initialVideoName = ''
}: UnattendedDialogProps = {}) => {
  const { isOpen, openDialog, closeDialog } = useDialog();
  const [lectureName, setLectureName] = useState(initialLectureName);
  const [videoName, setVideoName] = useState(initialVideoName);

  const openWithNames = (newLectureName: string, newVideoName?: string) => {
    setLectureName(newLectureName);
    if (newVideoName) {
      setVideoName(newVideoName);
    }
    openDialog();
  };

  return {
    isOpen,
    lectureName,
    videoName,
    openWithNames,
    closeDialog
  };
};

export interface VideoDialogProps {
  onSuccessCallback?: () => void;
  onErrorCallback?: (error: any) => void;
}

export const useVideoDialog = ({
  onSuccessCallback,
  onErrorCallback
}: VideoDialogProps = {}) => {
  const { isOpen, openDialog, closeDialog } = useDialog();
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [content, setContent] = useState<string | null>(null);
  const { get } = useAdminFetch();

  const openVideoDialog = async (contentTitle: string, fileName: string) => {
    setContent(contentTitle);
    try {
      const response = await get<{ url: string }>(`/api/admin/video/${fileName}`);
      setVideoUrl(response.url);
      openDialog();
    } catch (error) {
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    }
  };

  const handleCloseVideoDialog = () => {
    closeDialog();
    setVideoUrl(null);
  };

  const handleError = (e: any) => {
    const error = e.target?.error || e;
    if (onErrorCallback) {
      onErrorCallback(error);
    }
  };

  return {
    isOpen,
    videoUrl,
    content,
    openVideoDialog,
    handleCloseVideoDialog,
    handleError
  };
};